import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TransactionCategory } from '@shipstation/financial-services-ui-components';

import { WwexRegistrationModal } from '../../../../../components/wwex-registration-modal';
import type { WwexFormData } from '../../../../../components/wwex-registration-modal';
import { refreshSellerFreightProviders } from '../../../../../store/seller/seller.actions';
import { PaymentAndSubscriptionMegaContextProvider } from '../../../../../pages/settings/payment-and-subscription/context';
import FsuiContextProvider from '../../../../../financial-services-ui/fsui-context-provider';
import { FinancialServicesUIProviderWrapper } from '../../../../../financial-services-ui/financial-services-ui-provider-wrapper';
import Global from '../../../../../store/global-selectors';

type WwexRegistrationContainerProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (sellerFreightProviderId: number | null) => void;
};

export const WwexRegistrationContainer = ({ isOpen, onClose, onSuccess }: WwexRegistrationContainerProps) => {
  const dispatch = useDispatch();
  const sellerCurrencyCode = useSelector(Global.selectSellerDefaultCurrency);

  const handleSuccess = useCallback(
    (_data: WwexFormData, sellerFreightProviderId: number | null) => {
      // Refresh freight providers in Redux
      dispatch(refreshSellerFreightProviders());

      // Retry the booking flow with the newly-registered account (requote, not re-book).
      // The modal itself closes on success, so we don't call onClose() here too.
      onSuccess(sellerFreightProviderId);
    },
    [dispatch, onSuccess],
  );

  if (!isOpen) {
    return null;
  }

  return (
    <PaymentAndSubscriptionMegaContextProvider>
      <FsuiContextProvider currencyCode={sellerCurrencyCode} transactionCategory={TransactionCategory.AddFunds}>
        <FinancialServicesUIProviderWrapper>
          <WwexRegistrationModal isOpen={isOpen} onClose={onClose} onSuccess={handleSuccess} />
        </FinancialServicesUIProviderWrapper>
      </FsuiContextProvider>
    </PaymentAndSubscriptionMegaContextProvider>
  );
};
